import { notFound, redirect } from '@tanstack/react-router';
import { getAppEnv } from '~portal/env';
import { isStandalone } from '~portal/lib';

/**
 * @desc The section's `beforeLoad`: on the standalone build it goes to the agent, as every product
 * route does; where `VITE_RESTRICTED_NAV` is unset (production) it does not exist at all —
 * `notFound()`, exactly as an unknown path. The admin check is the layout's (see `route.tsx`).
 */
export function guardRestrictedSection(): void {
  if (isStandalone) {
    throw redirect({ to: '/chat/$conversationId', params: { conversationId: 'new' } });
  }
  if (!getAppEnv().restrictedNav) throw notFound();
}

/** @desc `/restricted` has no landing page of its own yet: its one destination is Experiments. */
export function openExperiments(): never {
  throw redirect({ to: '/restricted/experiments', replace: true });
}
